import LRU from 'app/shared/cache/lruCache';
import genericUtils from 'app/shared/utils/genericUtils';

interface DotData {
  [key: string]: unknown;
}

interface CacheActions {
  add(query: string, dotData: DotData): void;
  get(query: string): DotData | undefined;
  size(): number;
  clear(): void;
}

const dotMapCache = new LRU(5);

const cacheActions: CacheActions = {
  add(query = '', dotData: DotData = {}): void {
    const hashKey = genericUtils.hash(query).toString();

    if (!dotMapCache.read(hashKey)) {
      dotMapCache.write(hashKey, dotData);
    }
  },

  get(query: string): DotData | undefined {
    const hashKey = genericUtils.hash(query).toString();

    return dotMapCache.read(hashKey) as DotData | undefined;
  },

  size(): number {
    return dotMapCache.getSize();
  },

  clear(): void {
    return dotMapCache.clear();
  },
};

export default cacheActions;
